import {
    apiRequest,
    seminarDetail,
    seminarApprove
} from "../../../../../services/adapters/kepegawaian/seminarService"

class ApproveRepository {

    fetchDetail = async (query) => {
        return await apiRequest("get", seminarDetail, {
            params: query
        }, true)
    }

    fetchApprove = async (query) => {
        return await apiRequest("post", seminarApprove, {
            body: query
        }, true)
    }
}

export default ApproveRepository